import { getAuthorities } from '.';
import {
  ROLE_COMERCIAL,
  ROLE_PERMISSAO_CRIAR_VENDA,
  ROLE_SISTEMA,
} from './enum';

const canCriarVenda = () => {
  const { authorities, hasAuthority } = getAuthorities(
    [ROLE_COMERCIAL, ROLE_SISTEMA],
    ROLE_PERMISSAO_CRIAR_VENDA
  );

  return authorities.length > 0 && hasAuthority;
};

export const possuiPermissao = (permissao) => {
  const { _, hasAuthority } = getAuthorities([], permissao);
  return hasAuthority;
};

export const canExtender = () => {
  const { authorities } = getAuthorities([ROLE_SISTEMA]);

  return authorities.length > 0;
};

export default canCriarVenda;
